export const finderSteps = [
  {
    id: "s1",
    step: "01",
    title: "先用一句话锁定方向",
    desc: "打开页面先别急着翻列表。想清楚今晚是想轻松下饭、想烧脑反转，还是想找一部安静的电影，这会让后面的筛选快很多。",
  },
  {
    id: "s2",
    step: "02",
    title: "用搜索框做第一层过滤",
    desc: "在「全网资源库」输入片名、演员类型词或地区关键词，例如「悬疑」「纪录片」「法国」，结果会立刻收窄到匹配条目。",
  },
  {
    id: "s3",
    step: "03",
    title: "再按类型与画质收口",
    desc: "如果结果还是多，用类型筛选分出剧集、电影、动漫、综艺、纪录片，用画质筛选确认家里设备能不能吃下蓝光 4K。",
  },
  {
    id: "s4",
    step: "04",
    title: "拿不准就直接挑片单",
    desc: "实在没有目标时，从「高分片单合集」里按场景挑一个，比自己一条条翻要快，也不容易越选越乱。",
  },
  {
    id: "s5",
    step: "05",
    title: "确认进度再决定跟不跟",
    desc: "连载作品先看更新进度：已完结的适合一口气看完，更新中的要评估自己能不能接受等更，避免追到一半弃剧。",
  },
];

export const resourceTypes = [
  {
    id: "rt1",
    icon: "ri-play-circle-line",
    title: "在线直读类型",
    desc: "打开即看、无需转存，适合临时想看一段或者投屏到客厅。通常对网络稳定性要求较高，片源清晰度以页面标注的画质档为准。",
    points: ["随点随看", "适配投屏", "清晰度看档位"],
  },
  {
    id: "rt2",
    icon: "ri-folder-download-line",
    title: "转存与离线类型",
    desc: "需要先把文件保存到自己空间再播放，好处是画质往往更完整、可离线观看。适合打算长期收藏、或者网络条件不太稳定的情况。",
    points: ["画质更完整", "支持离线", "适合收藏"],
  },
  {
    id: "rt3",
    icon: "ri-translate-2",
    title: "字幕与音轨说明",
    desc: "同一部作品可能存在内嵌字幕、外挂字幕和不同音轨版本。挑选时留意条目说明里的字幕信息，外语片建议优先选择带中文字幕的版本。",
    points: ["留意字幕信息", "外语片选中字", "音轨可切换"],
  },
];